import { useEffect } from "react";

import { GetUserInfoRole, useGetUserInfo } from "../api";
import { useAuthStore, useUserStore } from "../lib/store";

export interface Permissions {
  // [key: string]: { [key: string]: boolean };
  home_page: {
    authorization_form: boolean;
  };
  authorization: {
    view_personal_account: boolean;
  };
  profile: {
    vew_profile: boolean;
    change_password: boolean;
  };
  applications: {
    view_applications: boolean;
    create_application: boolean;
    create_draft_application: boolean;
    edit_draft_application: boolean;
    delete_draft_application: boolean;
    extension_of_auction: boolean;
    cancel_application: boolean;
    moderate_application: boolean;
  };
  trade: {
    view_all_application: boolean;
    view_details_application: boolean;
    participation_in_auction: boolean;
    rebidding_application: boolean;
    view_auction_stages: boolean;
    extension_rebidding: boolean;
    depersonalization_name: boolean;
    select_winners: boolean;
    viewing_winners: boolean;
    trade_notifications: boolean;
  };
  notifications: {
    view_all_notification: boolean;
    view_trade_notification: boolean;
    view_self_notification: boolean;
  };
  admin_panel: {
    user_management: boolean;
    application_management: boolean;
    loading_books: boolean;
    setting_permissions: boolean;
  };
}

export const useUser = () => {
  const { id, role, isAuthenticated } = useAuthStore();
  const { setUser } = useUserStore();

  const query = useGetUserInfo(
    { id: id!, role: role as GetUserInfoRole },
    {
      query: {
        enabled: false,
      },
    },
  );

  const user = query.data?.data.payload ?? null;
  const permissions = (user?.permission ?? null) as unknown as Permissions | null;

  useEffect(() => {
    if (isAuthenticated) {
      query.refetch();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setUser(user);
  }, [user]);

  return { user, query, permissions };
};
